<template>
    <div id="konfigurator-order">
        <right-content-header></right-content-header>

        <h2>Objednávka</h2>

        <div class="objednavka-btn-text">
          <span>Krmivo na 4 týdny</span>
        </div>

        <div class="views-field views-field-field-model-cena-davky">
	    <div v-if="$store.state.mazlicek.krmivo.tydny.value !== 0" class="vaha-krmiva-celkem">
		<div class="cena-label">
		Váha krmiva
		</div>
		<div class="cena-value">
		    <span>{{ round(totalWeight / 100) / 10 }} kg / {{ round((totalWeight * 0.00220462262) * 10 | round) / 10 }} lb</span>
		</div>
	    </div>
	    <div v-else class="vaha-krmiva-celkem">
		<div class="cena-label">
		    Váha krmiva
		</div>
		<div class="cena-value">
		    <span>{{ naZkouskuVaha }} g</span>
		</div>
	    </div>
            <div class="cena-davky" v-if="showTotalPrice">
                <div class="cena-label">
                    Cena / den
                </div>
                <div v-show="!priceIsBeingCalculated" class="cena-value">
                    <span>{{ (pricePerDay + '').replace('.', ',') }} Kč</span>
                </div>
                <div v-show="priceIsBeingCalculated" class="cena-value"><span>přepočítávám</span></div>
            </div>
          <div class="cena-complete">
            <div class="cena-label">
              Cena
            </div>
            <div v-show="!priceIsBeingCalculated" class="cena-value"><span>{{ totalPrice }} Kč</span></div>
            <div v-show="priceIsBeingCalculated" class="cena-value"><span>přepočítávám</span></div>
          </div>
          <div v-if="isFirstOrder" class="cena-complete first-order">
            <div class="cena-label">
              Super cena na první měsíc
            </div>
            <div v-show="!priceIsBeingCalculated" class="cena-value">
              <span>{{ roundPrice(mazlicek.orderData.firstOrderPrice) }} Kč</span>
            </div>
            <div v-show="priceIsBeingCalculated" class="cena-value"><span>přepočítávám</span></div>
          </div>
        </div>

        <!--<div class="form-type-checkboxes">-->
        <!--<div class="form-type-checkbox">-->
        <!--<input id="extra-baleni-checkbox" type="checkbox" v-model="$store.state.mazlicek.krmivo.extraZabalit"/>-->
        <!--<label for="extra-baleni-checkbox">Extra balení</label>-->
        <!--</div>-->
        <!--</div>-->
        <div v-if="isFirstOrder" class="objednavka-btn-text first-order">
          <span v-html="firstOrderText" > </span>
        </div>
        <div v-if="additional_info_order" class="objednavka-btn-text">
          <span v-html="additional_info_order.content" > </span>
        </div>

        <div v-if="mazlicek.orderData.activeSubscription" class="objednavka-btn-text">
            {{ mazlicek.orderData.isFirstOrderSent ? 'První' : 'Další' }} krmivo odesíláme: {{ mazlicek.orderData.orderSendDate }}
        </div>
        <div v-else class="objednavka-btn">
            <button class="button" @click="objednatKrmivo">OBJEDNAT</button>
        </div>

        <info-modal
          v-show="showInfoModal"
          :button-text="'OK'"
          :message="infoModalMessage"
          @close="showInfoModal = false"
        />
    </div>
</template>

<script>
import {apiDrupal, apiSilex} from '@/api'
import RightContentHeader from './RightContentHeader'
import InfoModal from "./InfoModal";

export default {
      components: {
        'right-content-header': RightContentHeader,
        'info-modal': InfoModal
      },

      data: function () {
        return {
          tydny: [],
          mazlicek: this.$store.state.mazlicek,
          loading: this.$store.state.loading,
          naZkouskuCena: 100,
          naZkouskuVaha: 100,
          additional_info_order: null,
          firstOrderText: null,
          priceIsBeingCalculated: false,
          showInfoModal: false,
          infoModalMessage: null,
        }
      },
      computed: {
        isFirstOrder () {
          if(window.konfigurator.first_order !== undefined){
            return window.konfigurator.first_order;
          }
          return this.mazlicek.orderData.isFirstOrder
        },
        showTotalPrice () {
          return (this.mazlicek.krmivo.feedData.feedRatio !== null) && this.mazlicek.krmivo.feedData.feedRatio.showTotalPrice
        },
        imageSrc: function () {
          return 'https://dummyimage.com/200x200/000/fff&amp;text=ico'
        },
        pricePerDay () {
          if (this.$store.state.mazlicek.krmivo.tydny.value === 0) { return this.naZkouskuCena }

          // const weekCoeficient = Number(this.$store.state.mazlicek.krmivo.tydny.data.koeficient)
          // const pricePerDay = Number(this.$store.state.mazlicek.krmivo.cena.den) * Number(weekCoeficient)

          const pricePerDay = Number(this.$store.state.mazlicek.krmivo.cena.den)

          return Math.round(Number(pricePerDay) * 100) / 100
        },
        totalPrice () {
          const weeks = Number(this.mazlicek.krmivo.tydny.data.pocetTydnu)

          return this.roundPrice(this.pricePerDay * 7 * weeks)
        },
        totalWeight () {
          return this.$store.state.mazlicek.krmivo.tydny.value * 7 * this.weightFeedRatio
        },
        weightFeedRatio () {
          if(this.mazlicek.krmivo.feedData.feedRatio)
            return this.mazlicek.krmivo.feedData.feedRatio.weightFeedRatio
        },
        weeks () {
          if (this.mazlicek.jeStene) {
            return this.tydny.filter(item => item.pocetTydnu <= 4)
          } else {
            return this.tydny
          }
        }
      },
      methods: {
        roundPrice(price){
          return Math.round(price)
        },
        weekChanged () {
          const pocetT = this.$store.state.mazlicek.krmivo.tydny.value
          this.$store.state.mazlicek.krmivo.tydny.data = this.tydny.find(item => item.pocetTydnu == pocetT)
          this.priceIsBeingCalculated = true
          this.$store.dispatch('updateProduct', this.mazlicek).then(response => {
            this.mazlicek.krmivo.feedData = response.data.data.feedData
            this.mazlicek.krmivo.cena.den = this.mazlicek.krmivo.feedData.feedRatio.totalPrice
            this.$store.commit('setMazlicek', this.mazlicek)
            this.priceIsBeingCalculated = false
          })
        },
        objednatKrmivo: function () {
          this.$store.commit('setLoading', true)
          sessionStorage.pet_nid = this.mazlicek.nid
          sessionStorage.feed_nid = this.mazlicek.krmivo.nid
          apiDrupal.post('/set-order', {
            mazlicek: this.$store.state.mazlicek
          })
                .then(response => {
                  this.$store.commit('setLoading', false)
                  if (response.data.status.code === 409) {  // 409 Conflict
                    this.infoModalMessage = response.data.status.message
                    this.showInfoModal = true

                  } else {
                    window.location.href = '/kosik'
                  }
                  // console.log(response)
              // sessionStorage.konfigurator = {};
                }).catch(function (error) {
                  console.error(error)
                })
        },
        afterMounted: function () {
          let url = '/objednavka/tydny'
          if (this.mazlicek.jeStene) { url += '?puppy=true' }
          apiSilex.get(url).then((response) => {
            this.tydny = response.data.filter(item => item.pocetTydnu > 1)

            this.weekChanged()
          })

          apiSilex.get('/last_step?key_word=first_order').then(
            response => {
              this.firstOrderText = response.data
            }
          )

          apiSilex.get('/additional_info/2').then(response => {
            this.additional_info_order = response.data
          }).catch(error => console.error(error))
        },
        round (value) {
          value = Number(value)
          return Math.round(value)
        },
      },
      mounted: function () {
        // eslint-disable-next-line eqeqeq
        if (this.mazlicek.krmivo.nid != 0) {
          this.afterMounted()
        }
      },
      watch: {
        'mazlicek.krmivo.tydny.value': {
          deep: true,
          handler: function (val) {
            this.weekChanged()
          }

        },
        'mazlicek.productLoaded': {
          deep: true,
          handler: function (val) {
            if (val.value) { this.afterMounted() }
          }
        },
        'mazlicek.petLoaded': {
          deep: true,
          handler: function (val) {
//                    if (val.value)
                    // this.mountinMethod()
          }
        }
//            'mazlicek.krmivo.cena': {
//                deep: true,
//                handler: function (val) {
//                    console.log('asdasdasd');
//                    this.weekChanged()
//                }
//            }
      }
    }
</script>



// WEBPACK FOOTER //
// Order.vue?fc8f6654